import { getAuthToken } from './auth/tokenStorage';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Alert } from 'react-native';
import http from './http';

class LoanInfoService {
  async createLoanInfo(loanData: any) {
    const token = await getAuthToken();
    const response = await http.post('/api/loans-info', loanData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to save loan information');
    }
    
    return response.data.data;
  }
  
  async getLoanInfo(targetUserId?: string) {
    const url = targetUserId
      ? `/api/loans-info?targetUserId=${targetUserId}`
      : '/api/loans-info';

    const response = await http.get(url);

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch loan information');
    }

    return response.data.data || [];
  }
  
  async getLoanInfoById(id: string) {
    const response = await http.get(`/api/loans-info/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch loan information');
    }
    
    return response.data.data;
  }
  
  async updateLoanInfo(id: string, loanData: any) {
    const response = await http.patch(`/api/loans-info/${id}`, loanData);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to update loan information');
    }
    
    return response.data.data;
  }
  
  async deleteLoanInfo(id: string) {
    const response = await http.delete(`/api/loans-info/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete loan information');
    }
  }
  
  // Lock/Unlock functionality
  async lockLoanInfo(id: string) {
    const response = await http.post(`/api/loans-info/${id}/lock`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to lock loan information');
    }
  }
  
  async unlockLoanInfo(id: string, granteeEmails: string[]) {
    const response = await http.post(`/api/loans-info/${id}/unlock`, {
      granteeEmails,
    });
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to unlock loan information');
    }
  }
  
  async getLoanAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/loans-info/${id}/access-grants`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch access grants');
    }
    
    return response.data.data || [];
  }
}

export const loanInfoService = new LoanInfoService();